import i18n from '@/lang/i18n'
import CellGridRichText from '@/components/common/CellGridRichText.vue'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'

export const auditBottomPanelGridColumnDefs =
    (hideOriginalValue: boolean): (ColDef | ExportedColDef | ExportedColGroupDef)[] => ([
        {
            headerName: i18n.tc('audit.grid.field'),
            field: 'fieldName',
            type: AgGridColumnType.TEXT,
            width: 200,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('audit.grid.originalValue'),
            field: 'originalValue',
            type: AgGridColumnType.TEXT,
            width: 400,
            suppressSizeToFit: true,
            hide: hideOriginalValue,
            cellStyle: { 'white-space': 'normal', 'overflow-y': 'auto' },
            cellRendererFramework: CellGridRichText
        },
        {
            headerName: hideOriginalValue ? i18n.tc('audit.grid.value') : i18n.tc('audit.grid.updatedValue'),
            field: 'updatedValue',
            type: AgGridColumnType.TEXT,
            width: hideOriginalValue ? 800 : 400,
            suppressSizeToFit: true,
            cellStyle: { 'white-space': 'normal', 'overflow-y': 'auto' },
            cellRendererFramework: CellGridRichText
        }
    ])
